import { apiSlice } from "../../app/api/apiSlice";

function buildQueryParams(params) {
  return Object.entries(params)
    .filter(
      ([key, value]) => value !== undefined && value !== null && value !== ""
    ) // Remove undefined, null, and empty string values
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    )
    .join("&");
}

export const staticDataSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAreas: builder.query({
      query: ({ key, query, page, pageSize }) => {
        const params = {
          key,
          query,
          page,
          pageSize,
        };

        const queryString = buildQueryParams(params);
        return `/areas?${queryString}`;
      },
    }),
    getDepartments: builder.query({
      query: ({ key, query, page, pageSize }) => {
        const params = {
          key,
          query,
          page,
          pageSize,
        };

        const queryString = buildQueryParams(params);
        return `/departments?${queryString}`;
      },
    }),
    getSubDepartments: builder.query({
      query: ({ key, query, page, pageSize }) => {
        const params = {
          key,
          query,
          page,
          pageSize,
        };

        const queryString = buildQueryParams(params);
        return `/sub-departments?${queryString}`;
      },
    }),
  }),
});

export const {
  useGetAreasQuery,
  useGetDepartmentsQuery,
  useGetSubDepartmentsQuery,
} = staticDataSlice;
